import React from 'react';
import PropTypes from 'prop-types';

import { DemoPage } from '../../partials';

// Import code snippets as text.
const html = require('!raw-loader!flexbox-patterns/src/examples/photo.html');
const css = require('!raw-loader!flexbox-patterns/src/styles/photo.css');

export const PhotoDemo = ({ name }) => (
  <DemoPage title={name} html={html} css={css}>
    <p>
      What&rsquo;s a photo without a caption? Without flexbox, you would have to
      absolutely position this caption inside of the photo. But this is a little
      inefficient because it means you can&rsquo;t use the <code>padding</code>{' '}
      property on the photo to control the label&rsquo;s distance from the edge,
      and you have to manually set the
      <code>width</code> on the label to make the text wrap. With flexbox, you
      get all of this out of the box!{' '}
      <small>
        (Get it? Out of the <strong>box</strong>.)
      </small>
    </p>

    <p>
      By this point, you&rsquo;re already familiar with all of the properties we
      need for this. The only difference is now you&rsquo;re going to use
      different values to achieve the intended result:
    </p>

    <ul>
      <li>
        <code>justify-content: flex-end</code> aligns all of the children to the
        end of the main axis. In this case, we&rsquo;re using the default main
        axis, which is horizontal. So the label gets aligned to the right side
        of the container.
      </li>

      <li>
        <code>align-items: flex-end</code> does the same thing, but
        perpendicular to the main axis. This direction is also known as the{' '}
        <em>secondary axis</em>. So all of the children get aligned to the
        bottom of the container.
      </li>
    </ul>
  </DemoPage>
);

PhotoDemo.propTypes = {
  name: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./ui/views/demos/PhotoDemo.js